import React, { useState, useEffect } from 'react';
import { DrawerContext } from './contexts/drawerContextProvider';
import { NavigationDrawer } from './router/drawer';
import { NavigationMenu } from './router/NavigationMenu';
import { DrawerLayout } from '@brightlayer-ui/react-components';

import * as PXBThemes from '@brightlayer-ui/react-themes';
import { Outlet } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { I18nextProvider } from 'react-i18next';
import utilityCloudi18n from './i18n';
import enTranslation from './locales/en/translation.json';
import deTranslation from './locales/de/translation.json';
import frTranslation from './locales/fr/translation.json';
import { ToastContainer } from 'react-toastify';

import { StateProvider } from './contexts/StateContext';
import { NotificationsProvider } from './contexts/NotificationsContext';

import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './navigation/AppRouter';
import ResetPassword from './pages/ResetPassword/ResetPassword';

utilityCloudi18n.addResourceBundle('en', 'translation', enTranslation);
utilityCloudi18n.addResourceBundle('de', 'translation', deTranslation);
utilityCloudi18n.addResourceBundle('fr', 'translation', frTranslation);

export const SharedLayoutWrapper = (prop) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [forcedClosed, setForcedClosed] = useState(false);
    const [variant, setVariant] = useState('persistent');
    const { fullscreen } = prop;

    if (fullscreen) {
        document.getElementById('root').style.overflow = 'hidden';
        return <Outlet />;
    }
    else {
        document.getElementById('root').style.overflow = 'visible';
    }

    return (
        <I18nextProvider i18n={utilityCloudi18n}>
            <ThemeProvider theme={createTheme(PXBThemes.blue)}>
                <DrawerContext.Provider
                    value={{
                        drawerOpen,
                        setDrawerOpen,
                        forcedClosed,
                        setForcedClosed,
                        variant,
                        setVariant
                    }}
                >
                    <DrawerLayout drawer={<NavigationDrawer />} style={{ height: '100%' }}>
                        <NavigationMenu />
                        <Outlet />
                    </DrawerLayout>
                </DrawerContext.Provider>
            </ThemeProvider>
        </I18nextProvider>
    );
};

export const App = () => {
    const [showResetPasswordComponent, setShowResetPasswordComponent] = useState(false);
    const [fullscreen, setFullscreen] = useState(false);

    useEffect(() => {
        const url = window?.location?.href;
        if (url?.includes('/resetpassword')) {
            setShowResetPasswordComponent(true);
        }

        setFullscreen(url?.includes('fullscreen=true'));
    });

    return (
        <>
            {showResetPasswordComponent ? (
                <ResetPassword />
            ) : (
                <I18nextProvider i18n={utilityCloudi18n}>
                    <StateProvider>
                        <NotificationsProvider>
                            <BrowserRouter basename={'/'}>
                                <AppRouter SharedLayoutWrapper={(props) => <SharedLayoutWrapper {...props} fullscreen={fullscreen} />} />
                            </BrowserRouter>
                        </NotificationsProvider>
                    </StateProvider>
                    <ToastContainer />
                </I18nextProvider>
            )}
        </>
    );
};
